import type { IEmployeeLocationFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import type { ContactsRequestPayload } from "app/pages/sales-intelligence/modules/company-analysis/types/contacts";
import type {
    ActionsPanelFilters,
    ContactDetails,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ContactsSearchResultsRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";
import { CONTACTS_SEARCH_TABLE_PAGE_SIZE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

/**
 * Building correct DTO object to request decision makers data
 * @param payload
 */
export function createContactsRequestDto(
    payload: ContactsRequestPayload,
): ContactsSearchResultsRequestDto & Partial<ActionsPanelFilters> {
    const {
        domain,
        currentPage,
        selectedProfile,
        pageSize = CONTACTS_SEARCH_TABLE_PAGE_SIZE,
        selectedCountriesIds,
        sortBy,
    } = payload;
    const profiles = selectedProfile !== null ? [selectedProfile] : [];
    const contactDetailsDto =
        Object.keys(payload.contactDetails).length === 0 ? {} : { contactDetails: payload.contactDetails };
    const actionsPanelFilters = {
        ...payload.actionsPanelFilters,
    };
    delete actionsPanelFilters.page;

    const employeeLocationDto: { employeeLocation?: IEmployeeLocationFilterDto } = selectedCountriesIds?.length
        ? {
              employeeLocation: {
                  inclusion: inclusionOptionMap.includeOnly,
                  codes: selectedCountriesIds,
              },
          }
        : {};

    const dto: ContactsSearchResultsRequestDto = {
        pageSize,
        ...sortBy,
        device: "Total",
        isNewOnly: false,
        excludeUserLeads: false,
        page: currentPage,
        includeDomains: [domain],

        queryFilters: {
            contactsFilters: {
                profiles,
                searchText: payload.searchText,
                ...employeeLocationDto,
                ...contactDetailsDto,
            },
            leadsFilters: {},
        },
        ...actionsPanelFilters,
    };

    return dto;
}

/**
 * Retrieve a correct variant from given `contactDetails` object
 * @param contactDetails
 */
export function getSelectedContactDetailsType(contactDetails: ContactDetails): ContactDetail | null {
    if (contactDetails.hasEmailAndMobilePhone) {
        return ContactDetail.EmailAndMobilePhone;
    }

    if (contactDetails.hasDirectPhone) {
        return ContactDetail.DirectPhone;
    }

    if (contactDetails.hasEmail) {
        return ContactDetail.Email;
    }

    if (contactDetails.hasMobilePhone) {
        return ContactDetail.MobilePhone;
    }

    return null;
}
